import CleanUrl from './CleanUrl';

const IsUrlBlocked = (blockedUrls, targetUrl) => {
    if (blockedUrls && blockedUrls.trim() !== '') {
        // Clean the target URL
        targetUrl = CleanUrl(targetUrl);

        // Split the blocked URLs list into individual URLs
        const blockedUrlList = blockedUrls.split(',');
        for (let i = 0; i < blockedUrlList.length; i++) {
            const blockedUrl = CleanUrl(blockedUrlList[i]);
            // Check for exact match
            if (blockedUrl === targetUrl) {
                return true;
            }
            // Check if the blocked URL ends with "/*" to handle subdirectories
            if (blockedUrl.endsWith('/*')) {
                // Remove "/*" to get the base URL
                const baseBlockedUrl = blockedUrl.substring(0, blockedUrl.length - 2);

                // Check if the targetUrl starts with the base URL
                if (targetUrl.startsWith(baseBlockedUrl)) {
                    return true;
                }
            }
        }
    }
    return false;
};
export default IsUrlBlocked;
